// extracted by mini-css-extract-plugin
module.exports = {"StyleTable":"styles_StyleTable__30VqX","tableLeft":"styles_tableLeft__vQ0gW","titleLeft":"styles_titleLeft__vLarW","titleRight":"styles_titleRight__Fycev"};